import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import publicRoute from './routes/public';
import privateRoute from './routes/private';
import GlobalDialog from '@/components/molecule/GlobalDialog/GlobalDialog';
import testRoute from '@/src/routes/testRoute';
import { useToast } from './hooks/useToast';
import GlobalBlockDialog from './components/molecule/GlobalBlockDialog';

const isDev = process.env.REACT_APP_ENV_MODE === 'dev';
const router = createBrowserRouter([
  ...privateRoute,
  ...publicRoute,
  ...testRoute,
]);

function App() {
  const { toast } = useToast();
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (
          query?.meta?.backUrl &&
          typeof query?.meta?.callback === 'function'
        ) {
          query.meta.callback();
          toast({
            variant: 'error',
            title: '실패',
            description: error?.message,
          });
        }
      },
    }),
    defaultOptions: {
      queries: {
        retry: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
      <GlobalDialog />
      <GlobalBlockDialog />
      {isDev && <ReactQueryDevtools />}
    </QueryClientProvider>
  );
}

export default App;
